import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    minHeight: 200
  },
  withMargin: {
    margin: theme.spacing(1)
  },
  paperHeader: {
    justifyContent: 'space-between'
  },
  paperHeaderIcon: {
    color: theme.palette.primary.main
  }
}));
